import { EntityProvidedApisCard, EntityConsumedApisCard } from '@backstage/plugin-api-docs';
import {
  EntityLayout,
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
} from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import { OverviewContent, CICDContent, TechDocsContent } from '../../../components/entity-content';

/**
 * The layout for a Component entity.
 *
 * There used to be three files here: service.tsx, infrastructure.tsx and website.tsx.
 * infrastructure.tsx was a byte-for-byte copy of service.tsx (only the exported name differed) and
 * website.tsx was the same page minus the API tab — so a change to the Overview or CI/CD tab had to
 * be made in three places, and in practice drifted.
 *
 * `withApis` is the only real difference: a website provides/consumes no catalog APIs.
 */
export const componentEntityPage = ({ withApis }: { withApis: boolean }) => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {OverviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="CI/CD">
      {CICDContent}
    </EntityLayout.Route>

    {withApis && (
      <EntityLayout.Route path="/api" title="API">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <EntityProvidedApisCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumedApisCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
    )}

    <EntityLayout.Route path="/dependencies" title="Dependencies">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6}>
          <EntityDependsOnComponentsCard />
        </Grid>
        <Grid item md={6}>
          <EntityDependsOnResourcesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {TechDocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
